import { render, staticRenderFns } from "./HeroAsideWrapper.vue?vue&type=template&id=0e0a7140&scoped=true&"
import script from "./HeroAsideWrapper.vue?vue&type=script&lang=js&"
export * from "./HeroAsideWrapper.vue?vue&type=script&lang=js&"
import style0 from "./HeroAsideWrapper.vue?vue&type=style&index=0&id=0e0a7140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a7140",
  null
  
)

export default component.exports